module.exports = __webpack_public_path__ + "static/media/facturatie.917bf50a.svg";